// extracted by mini-css-extract-plugin
export var wasteDetail = "WasteDetailItem-module--wasteDetail--cgLCR";
export var wasteDetailCell = "WasteDetailItem-module--wasteDetailCell---FQ8x";
export var wasteDetailItem = "WasteDetailItem-module--wasteDetailItem--2sjs-";